import Vue from 'vue'
import Router from 'vue-router'
import { store } from '@/store'

// general layout
const NotFound = () => import('@/views/404')
const login = () => import('@/views/login')
const index = () => import('@/views/index')

// firms
const FirmsHeader = () => import('@/views/firms/header')
const FirmsList = () => import('@/views/firms/list')
const FirmsDetail = () => import('@/views/firms/detail')
const FirmsDetailHeader = () => import('@/views/firms/detailHeader')

// accounts
const accountsHeader = () => import('@/views/accounts/header')
const accountsList = () => import('@/views/accounts/list')
const accountsDetail = () => import('@/views/accounts/detail')
const accountsDetailHeader = () => import('@/views/accounts/detailHeader')

Vue.use(Router)

const router = new Router({
  mode: 'history',
  scrollBehavior(to, from, savedPosition) {
    return {
      x: 0,
      y: 0
    }
  },
  base: process.env.BASE_URL,
  routes: [
    {
      path: '*',
      name: 'default',
      component: NotFound,
      meta: {
        isPublic: true
      }
    },
    {
      path: '/404',
      name: 'http404',
      component: NotFound,
      meta: {
        isPublic: true
      }
    },
    {
      path: '/',
      name: 'login',
      component: login,
      meta: {
        isPublic: true
      }
    },
    {
      path: '/firms',
      component: index,
      name: 'firms',
      children: [
        {
          path: 'list',
          name: 'firmsList',
          components: {
            default: FirmsList,
            header: FirmsHeader
          }
        },
        {
          path: 'edit/:_id',
          name: 'firmsEdit',
          components: {
            default: FirmsDetail,
            header: FirmsDetailHeader
          }
        },
        {
          path: 'add',
          name: 'firmsAdd',
          components: {
            default: FirmsDetail,
            header: FirmsDetailHeader
          }
        }
      ]
    },
    {
      path: '/accounts',
      component: index,
      name: 'accounts',
      meta: {
        isAdmin: true
      },
      children: [
        {
          path: 'list',
          name: 'accountsList',
          components: {
            default: accountsList,
            header: accountsHeader
          }
        },
        {
          path: 'edit/:_id',
          name: 'accountsEdit',
          components: {
            default: accountsDetail,
            header: accountsDetailHeader
          }
        },
        {
          path: 'add',
          name: 'accountsAdd',
          components: {
            default: accountsDetail,
            header: accountsDetailHeader
          }
        }
      ]
    }
  ]
})

router.beforeEach(async (to, from, next) => {
  if (to.matched.some(route => route.meta.isPublic)) {
    store.set(
      'router/matchedRoutes',
      to.matched.map(t => t.name)
    )
    return next()
  }

  const isValidUser = await store.dispatch('auth/verifyUser')
  if (isValidUser) {
    let adminUser = store.get('auth/isAdmin')
    if (to.matched.some(route => route.meta.isAdmin && !adminUser)) {
      return next({
        name: 'http404'
      })
    }

    store.set(
      'router/matchedRoutes',
      to.matched.map(t => t.name)
    )
    return next()
  }

  return next({
    name: 'login'
  })
})

export default router
